import IconSvg from "@components/core/IconSvg";
import useFeatures from "@hooks/use-features";
import { usePrice } from "@hooks/use-prices";
import catalogContexts from "@utils/constants/catalogContexts";

function ProductSalesRibbon({ context, product }) {
  const features = useFeatures();
  const price = usePrice();

  if (!product?.id || context !== catalogContexts.sales) return null;

  const priceDiff = product?.retail_price - product?.current_price;
  const calculatedDiscountPercent = Math.round((priceDiff / product?.retail_price) * 100);
  const displayDiscountBadge = calculatedDiscountPercent > features?.min_discount_to_display;

  return (
    <div className="catalog-product-sales-ribbon">
      <span className="icon-container">
        <IconSvg name="price-tag-icon" />
      </span>
      <span className="text-white font-weight-bold font-size-sm">
        {`${price(product.current_price, { withoutCents: true, withoutSpace: true })}${displayDiscountBadge ? ` (-${calculatedDiscountPercent}%)` : ""}`}
      </span>
    </div>
  );
}

export default ProductSalesRibbon;
